import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import Header from '@/components/Header';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { Video, Upload, DollarSign, Eye } from 'lucide-react';

const VendezVideoPage = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  const handleStartSelling = () => {
    if (!user) {
      navigate('/auth');
      return;
    }
    navigate('/vendre-videos');
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-black via-zinc-900 to-black">
      <Header />
      
      <div className="pt-32 pb-20 px-4">
        {/* Hero Simple */}
        <div className="max-w-4xl mx-auto text-center">
          <Video size={64} className="text-[#E50914] mx-auto mb-8" />
          
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">
            Vendez vos Vidéos
          </h1>
          
          <p className="text-2xl text-zinc-300 mb-4">
            sur <span className="text-[#E50914] font-bold">AGRP BOX</span>
          </p>
          
          <p className="text-xl text-zinc-400 mb-12 max-w-2xl mx-auto">
            Publiez vos clips, films et comédies. <br/>
            Fixez votre prix et gagnez de l'argent.
          </p>

          <Button
            onClick={handleStartSelling}
            className="bg-[#E50914] hover:bg-[#b8070f] text-white text-xl px-12 py-8 h-auto mb-16"
          >
            <Upload className="mr-3" size={28} />
            {user ? 'Publier une Vidéo' : 'Commencer Gratuitement'}
          </Button>

          {/* 3 Avantages Simples */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-20">
            <Card className="bg-zinc-900/50 border-zinc-800">
              <CardContent className="p-8 text-center">
                <Upload size={40} className="text-[#E50914] mx-auto mb-4" />
                <h3 className="text-xl font-bold text-white mb-2">Upload Facile</h3>
                <p className="text-zinc-400">En quelques clics</p>
              </CardContent>
            </Card>
            
            <Card className="bg-zinc-900/50 border-zinc-800">
              <CardContent className="p-8 text-center">
                <DollarSign size={40} className="text-[#E50914] mx-auto mb-4" />
                <h3 className="text-xl font-bold text-white mb-2">Votre Prix</h3>
                <p className="text-zinc-400">Vous décidez</p>
              </CardContent>
            </Card>
            
            <Card className="bg-zinc-900/50 border-zinc-800">
              <CardContent className="p-8 text-center">
                <Eye size={40} className="text-[#E50914] mx-auto mb-4" />
                <h3 className="text-xl font-bold text-white mb-2">Visibilité</h3>
                <p className="text-zinc-400">Immédiate</p>
              </CardContent>
            </Card>
          </div>

          {/* CTA Simple */}
          <Card className="bg-[#E50914] border-0 max-w-2xl mx-auto">
            <CardContent className="p-12 text-center">
              <h2 className="text-3xl font-bold text-white mb-6">
                Prêt à Commencer ?
              </h2>
              <Button
                onClick={handleStartSelling}
                className="bg-white text-[#E50914] hover:bg-zinc-100 text-lg px-10 py-6 h-auto font-bold"
              >
                <Upload className="mr-2" size={24} />
                C'est Gratuit !
              </Button>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default VendezVideoPage;
